import { BaseTarget } from "@/lib/filtering/filters";
import { InputTag } from "@components/PromptEditor/VariableTags";
import { BracketsCurly } from "@phosphor-icons/react";

export const InputFilterTargetLabelRenderer = (filterTarget: BaseTarget) => {
  return <InputTag size={20}>{filterTarget.label}</InputTag>;
};

export const InputsFilterTargetLabelRenderer = (filterTarget: BaseTarget) => {
  return (
    <div className="flex items-center gap-6 fill-icon-base-3">
      <BracketsCurly size={14} className="fill-icon-base-3  group-data-[highlighted]:fill-icon-base-1 " />
      <span className="text-12-12 font-medium text-text-base-1">Inputs</span>
    </div>
  );
};
